var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobListLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C43.464 56 56 43.464 56 28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7445 34.2329C20.1353 34.2329 22.8843 31.4839 22.8843 28.0931C22.8843 24.7023 20.1353 21.9538 16.7445 21.9538C13.3537 21.9538 10.6052 24.7023 10.6052 28.0931C10.6052 31.4839 13.3537 34.2329 16.7445 34.2329ZM16.7445 36.6516C21.4714 36.6516 25.3029 32.8195 25.3029 28.0931C25.3029 23.3667 21.4714 19.5352 16.7445 19.5352C12.0181 19.5352 8.18652 23.3667 8.18652 28.0931C8.18652 32.8195 12.0181 36.6516 16.7445 36.6516Z",
    fill: "#CA3137"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4423 36.6516C44.1687 36.6516 48.0002 32.8195 48.0002 28.0931C48.0002 23.3667 44.1687 19.5352 39.4423 19.5352C34.7159 19.5352 30.8838 23.3667 30.8838 28.0931C30.8838 32.8195 34.7159 36.6516 39.4423 36.6516Z",
    fill: "#CA3137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobListLogo4);
export default __webpack_public_path__ + "static/media/job-list-logo-4.47163280ab83061353454a1fd941b502.svg";
export { ForwardRef as ReactComponent };